import { render, staticRenderFns } from "./CodeGeneratorPreview.vue?vue&type=template&id=2b464902&scoped=true&"
import script from "./CodeGeneratorPreview.vue?vue&type=script&lang=js&"
export * from "./CodeGeneratorPreview.vue?vue&type=script&lang=js&"
import style0 from "./CodeGeneratorPreview.vue?vue&type=style&index=0&id=2b464902&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b464902",
  null
  
)

export default component.exports